// extracted by mini-css-extract-plugin
export default {"container":"Category_container__7rKu-","container_images":"Category_container_images__IJnIc","title":"Category_title__b0gYk"};